export default __webpack_public_path__ + "static/media/sharpspringIcon.b771d3a0.svg";